<template>
  <div class="dashboard-pages">
    <v-card>
      <v-layout row wrap justify-space-between>
        <dt-search-box
          :search="search"
          @typing="searchValue"
          @reset-datatable="resetDataTable()"
          @clear-search-field="search = null"
        />

        <!--        <v-layout row wrap justify-end pt-2 pb-2>-->
        <!--          <v-btn-->
        <!--            dark-->
        <!--            color="primary"-->
        <!--            v-if="hasPermissions(['remittance_transactions_store'])"-->
        <!--            @click="dialogs.addDialog = true"-->
        <!--          >-->
        <!--            <v-icon>add</v-icon>-->
        <!--            {{ $t('datatable-add-new') }}-->
        <!--          </v-btn>-->
        <!--        </v-layout>-->
      </v-layout>
    </v-card>

    <v-card flat>
      <v-layout row wrap justify-end>
        <v-tooltip :left="!$vuetify.rtl" :right="$vuetify.rtl">
          <template v-slot:activator="{ on }">
            <v-btn
              style="margin: 5px 0px; height: 30px; width: 30px"
              :loading="loadThePrintBtn"
              flat
              fab
              v-on="on"
              color="primary"
              @click="getNoPaginatedData('print')"
            >
              <v-icon>print</v-icon>
            </v-btn>
          </template>
          <span>{{ $t(`Print Table`) }}</span>
        </v-tooltip>
        <v-tooltip :left="!$vuetify.rtl" :right="$vuetify.rtl">
          <template v-slot:activator="{ on }">
            <v-btn
              style="margin: 5px 20px 5px 10px; height: 30px; width: 30px"
              fab
              :loading="loadTheExportBtn"
              flat
              v-on="on"
              color="primary"
              @click="getNoPaginatedData('export')"
            >
              <v-icon>fa-file-excel</v-icon>
            </v-btn>
          </template>
          <span>{{ $t(`Export Table`) }}</span>
        </v-tooltip>
      </v-layout>
    </v-card>

    <v-card px-4 pb-4>
      <v-data-table
        :headers="headers"
        :items="resultData.data"
        :item-key="defaultSortBy"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="pagination.rowsPerPageItems"
        :total-items="resultData.total"
        :no-data-text="$t('No available data')"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <!--          <td>{{ props.item.remittance_transaction_id }}</td>-->
          <td>{{ props.item.transaction_no }}</td>
          <td>{{ props.item.vender_name || props.item.customer_name }}</td>
          <td>{{ $t(props.item.transaction_type) }}</td>
          <!--          <td>{{ $t(props.item.currency_type) }}</td>-->
          <td>{{ props.item.transaction_date }}</td>
          <td>{{ props.item.amount | currency }}</td>

          <td v-if="hasActionsMenuPermissions()">
            <v-menu offset-y bottom :left="!$vuetify.rtl" :right="$vuetify.rtl" transition="slide-y-reverse-transition">
              <v-btn flat fab icon transparent py-2 slot="activator">
                <v-icon large class="grey--text" actions-btn>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-tooltip
                  v-if="hasPermissions(['remittance_transactions_show'])"
                  :left="!$vuetify.rtl"
                  :right="$vuetify.rtl"
                >
                  <v-list-tile slot="activator" @click="viewRecord(props.item.remittance_transaction_id)">
                    <v-icon>chrome_reader_mode</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('datatable-view') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t(`View Remittance Transaction's Information`) }}</span>
                </v-tooltip>

                <!--                <v-tooltip-->
                <!--                  v-if="hasPermissions(['remittance_transactions_update'])"-->
                <!--                  :left="!$vuetify.rtl"-->
                <!--                  :right="$vuetify.rtl"-->
                <!--                >-->
                <!--                  <v-list-tile slot="activator" @click="editRecord(props.item.remittance_transaction_id)">-->
                <!--                    <v-icon>edit</v-icon>-->
                <!--                    <v-list-tile-content class="px-3">{{ $t('datatable-edit') }}</v-list-tile-content>-->
                <!--                  </v-list-tile>-->
                <!--                  <span>{{ $t(`Edit Remittance Transaction's Information`) }}</span>-->
                <!--                </v-tooltip>-->

                <!--                <v-divider v-if="hasPermissions(['remittance_transactions_destroy'])" />-->

                <!--                <v-tooltip-->
                <!--                  v-if="hasPermissions(['remittance_transactions_destroy'])"-->
                <!--                  :left="!$vuetify.rtl"-->
                <!--                  :right="$vuetify.rtl"-->
                <!--                >-->
                <!--                  <v-list-tile slot="activator" @click="showConfirmDeletion(props.item.remittance_transaction_id)">-->
                <!--                    <v-icon class="red&#45;&#45;text">delete</v-icon>-->
                <!--                    <v-list-tile-content class="red&#45;&#45;text px-3">{{ $t('datatable-delete') }}</v-list-tile-content>-->
                <!--                  </v-list-tile>-->
                <!--                  <span>{{ $t('Delete Remittance Transaction Record') }}</span>-->
                <!--                </v-tooltip>-->
              </v-list>
            </v-menu>
          </td>
        </template>

        <v-alert slot="no-results" :value="true" color="error" icon="warning">{{
          $t('Sorry, No results found for your search criteria')
        }}</v-alert>
      </v-data-table>

      <dt-pagination
        :resultData="resultData"
        :pagination="pagination"
        :perPageNumber="perPageNumber"
        @page-changed="pageChanged"
        @per-page-changed="resultsPerPageChanged"
      />
    </v-card>

    <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% Dialogs %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% -->

    <view-remittance-transaction :viewDialog="dialogs.viewDialog" @hidemodal="dialogs.viewDialog = false" />

    <!--    <add-remittance-transaction-->
    <!--      :addDialog="dialogs.addDialog"-->
    <!--      :remittanceInfo="remittanceInfo"-->
    <!--      @reset-datatable="resetDataTable(), resetAllErrors(true)"-->
    <!--      @hidemodal="resetAllErrors(true), (dialogs.addDialog = false)"-->
    <!--    />-->

    <!--    <edit-remittance-transaction-->
    <!--      :editDialog="dialogs.editDialog"-->
    <!--      @updated="updateDatatableResult(), (dialogs.editDialog = false), (allowGettingData = false)"-->
    <!--      @hidemodal="resetAllErrors(true), (dialogs.editDialog = false)"-->
    <!--    />-->

    <confirm-deletion
      :deleteDialog="dialogs.deleteDialog"
      :btnDeleteLoading="btnDeleteLoading"
      @hidemodal="dialogs.deleteDialog = false"
      @confirm="deleteAction()"
    />

    <print-export-component
      :printExportDialog="dialogs.printExportDialog"
      :tableHeader="tableHeader"
      :tableBody="tableBody"
      :clickedButton="clickedButton"
      @hidemodal="dialogs.printExportDialog = false"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import Axios from 'axios'

export default {
  components: {
    dtSearchBox: () => import('@/views/_partials/AppSearchBox.vue'),
    dtPagination: () => import('@/views/_partials/AppDatatablePagination.vue'),
    viewRemittanceTransaction: () => import('./viewRemittanceTransaction.vue'),
    // addRemittanceTransaction: () => import('./addRemittanceTransaction.vue'),
    // editRemittanceTransaction: () => import('./editRemittanceTransaction.vue'),
    printExportComponent: () => import('@/views/_partials/printExportComponent.vue')
  },

  data() {
    return {
      id: Number(this.$route.query.id),
      name: this.$route.query.name,
      dialogs: {
        viewDialog: false,
        addDialog: false,
        editDialog: false,
        deleteDialog: false,
        printExportDialog: false
      },
      tableBody: [],
      tableHeader: [],
      loadThePrintBtn: false,
      loadTheExportBtn: false,
      clickedButton: '',
      deleteId: 0,
      btnDeleteLoading: false,
      search: null,
      oldSearch: null,
      loading: false,
      defaultSortBy: 'remittance_transaction_id',
      perPageNumber: 10,
      pagination: {
        sortBy: this.defaultSortBy,
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 1
      },
      oldPagination: {},
      headers: [
        // {
        //   text: this.$t('ID'),
        //   value: 'remittance_transaction_id',
        //   align: 'left',
        //   sortable: true
        // },
        { text: this.$t('Transaction No.'), value: 'transaction_no' },
        { text: this.$t('Consumer'), value: 'customer_name' },
        { text: this.$t('Transaction Type'), value: 'transaction_type' },
        // { text: this.$t('Currency Type'), value: 'currency_type' },
        { text: this.$t('Date'), value: 'transaction_date' },
        { text: this.$t('Amount'), value: 'amount' }
      ],
      allowGettingData: true
    }
  },

  mounted() {
    this.setAppBarTitle({
      title: `${this.$t('Remittance Transactions')}: <strong class="title-highlight">${this.name}</strong>`,
      icon: 'attach_money'
    })

    if (this.hasActionsMenuPermissions()) {
      this.headers.push({
        text: this.$t('datatable-actions'),
        value: '',
        sortable: false
      })
    }
  },

  computed: {
    ...mapGetters({
      resultData: 'remittanceTransactions/getTransactionsList',
      remittanceInfo: 'remittances/getRemittanceOfficeInfo'
    })
  },

  watch: {
    pagination: {
      immediate: true,
      handler() {
        let p = this.pagination
        let op = this.oldPagination
        if (p.sortBy !== op.sortBy || p.descending !== op.descending) {
          op.sortBy = p.sortBy
          op.descending = p.descending
          p.page = 1
          this.updateDatatableResult()
          this.allowGettingData = !this.allowGettingData
        } else if (this.allowGettingData || this.search !== this.oldSearch) {
          this.oldSearch = this.search
          this.updateDatatableResult()
          this.allowGettingData = !this.allowGettingData
        }
      }
    }
  },

  methods: {
    ...mapActions({
      resetAllErrors: 'errors/resetAllErrors',
      setErrorsList: 'errors/setErrorsList',
      updateResult: 'remittanceTransactions/updateTransactionsList',
      deleteRecord: 'remittanceTransactions/deleteTransaction',
      fetchRemittanceOfficeInfo: 'remittances/fetchRemittanceOfficeInfo',
      fetchInfo: 'remittanceTransactions/fetchTransactionInfo'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    hasActionsMenuPermissions() {
      return helpers.userHasPermissions([
        'remittance_transactions_show',
        'remittance_transactions_update',
        'remittance_transactions_destroy'
      ])
    },

    getNoPaginatedData(clickedButton) {
      this.clickedButton = clickedButton
      if (clickedButton === 'print') {
        this.loadThePrintBtn = true
      } else if (clickedButton === 'export') {
        this.loadTheExportBtn = true
      }
      this.tableBody = []
      this.tableHeader = []
      this.tableHeader = this.headers
      this.tableHeader = this.tableHeader.filter(f => f.text !== 'Actions' && f.text !== 'الاجراءات')

      Axios.get(`remittance_transactions_index/${this.id}`, {
        params: { is_paginated: 0, search: this.search }
      })
        .then(response => {
          this.tableBody = response.data.data
          this.loadThePrintBtn = false
          this.loadTheExportBtn = false
          this.dialogs.printExportDialog = true
        })
        .catch(() => {
          this.loadThePrintBtn = false
          this.loadTheExportBtn = false
          this.dialogs.printExportDialog = false
        })
    },

    updateDatatableResult() {
      this.loading = true
      let payload = {
        ...this.pagination,
        search: this.search,
        id: this.id
      }
      this.updateResult(payload)
        .then(() => {
          this.pagination.page = this.resultData.current_page
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
      this.fetchRemittanceOfficeInfo(this.id)
    },

    resetDataTable() {
      this.allowGettingData = true
      this.pagination = {
        sortBy: null,
        descending: true,
        page: 1,
        rowsPerPage: this.perPageNumber,
        totalItems: 1
      }
      this.search = this.oldSearch = null
    },

    resultsPerPageChanged(val) {
      this.perPageNumber = val
      this.pagination.rowsPerPage = val
      this.pagination.page = 1
      this.updateDatatableResult()
    },

    pageChanged(val) {
      this.pagination.page = val
      this.updateDatatableResult()
    },

    searchValue(val) {
      this.search = val
    },

    viewRecord(id) {
      this.fetchInfo(id).then(() => {
        this.dialogs.viewDialog = true
      })
    },

    editRecord(id) {
      this.fetchInfo(id).then(() => {
        this.dialogs.editDialog = true
      })
    },

    showConfirmDeletion(id) {
      this.deleteId = id
      this.dialogs.deleteDialog = true
    },

    deleteAction() {
      this.btnDeleteLoading = true
      this.deleteRecord(this.deleteId)
        .then(() => {
          this.deleteId = 0
          this.btnDeleteLoading = false
          this.dialogs.deleteDialog = false
          let payload = { ...this.pagination, search: this.search, id: this.id }
          this.updateResult(payload)
        })
        .catch(() => {
          this.deleteId = 0
          this.btnDeleteLoading = false
          this.dialogs.deleteDialog = false
        })
      this.fetchRemittanceOfficeInfo(this.id)
    }
  }
}
</script>

<style scoped />
